import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as styles from '../MainLayout.module.less';

const Trigger = () => (
  <div className={styles['sidebar-trigger-wrapper']}>
    <FormattedMessage id="navigation.collapse" defaultMessage="Collapse" />
    <div className={styles['sidebar-trigger']}>
      <i className="fb-icon fb-icon--arrow-left" />
    </div>
  </div>
);

export default Trigger;
